// extracted by mini-css-extract-plugin
export var productImage = "_px-0";